import(/* webpackMode: "eager", webpackExports: ["Loader"] */ "/root/instacks_staging/instacks_ui/src/components/ui/loader.tsx");
